<div class="row mb-3">
  <div class="col-8 col-lg-8">
    <mat-label class="heading">{{ "addWorkExperience" | translate }}</mat-label>
  </div>
  <div class="col-4 col-lg-4">
    <div class="d-flex justify-content-end">
      <mat-icon (click)="closeNotif()">close</mat-icon>
    </div>
  </div>
</div>

<form [formGroup]="editWorkExperienceFormGroup">
  <div class="row">
    <div class="mb-2" [class.col-lg-6]="countrySelected !== 'Philippines'"
      [class.col-lg-4]="countrySelected === 'Philippines'">
      <mat-form-field appearance="outline" [style.width.%]="100">
        <mat-label>{{ "companyName" | translate }}</mat-label>
        <input matInput formControlName="companyName" appNoLeadingSpaces />
      </mat-form-field>
    </div>
    <div class="mb-2" [class.col-lg-6]="countrySelected !== 'Philippines'"
      [class.col-lg-4]="countrySelected === 'Philippines'">
      <mat-form-field appearance="outline" [style.width.%]="100">
        <mat-label>Country</mat-label>
        <input type="text" matInput formControlName="country" appNoLeadingSpaces [matAutocomplete]="countries"
          [(ngModel)]="countrySelected" (ngModelChange)="onCountrySelectionChange($event)" />
        <mat-autocomplete #countries="matAutocomplete">
          <mat-option *ngFor="let country of filteredCountries | async" [value]="country.name">
            {{ country.name }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>
    <div class="col-lg-4" *ngIf="countrySelected == 'Philippines'">
      <mat-form-field appearance="outline" [style.width.%]="100">
        <mat-label *ngIf="!showTagalog">{{ "address" | translate }}</mat-label>
        <input type="text" matInput formControlName="cityId" appNoLeadingSpaces [matAutocomplete]="auto">
        <mat-autocomplete #auto="matAutocomplete">
          <mat-option *ngFor="let city of filteredCities | async" [value]="city.name"
            (onSelectionChange)="onSelectCity(city.id)">
            {{ city.name }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
      <mat-hint class="mt-2">City/Municipality</mat-hint>
    </div>
  </div>
  <mat-checkbox [(ngModel)]="isChecked" (change)="toggleFormField()" [ngModelOptions]="{standalone: true}" class="mb-2"
    style="font-size: 13px;">Currently working in this role</mat-checkbox>

  <div class="row mb-3">
    <div class="col-12 col-lg-6 mb-2">
      <mat-form-field appearance="outline" [style.width.%]="100">
        <mat-label *ngIf="!showTagalog">{{ "startContract" | translate }}</mat-label>
        <input matInput [matDatepicker]="startContract" readonly="true" formControlName="startOfContractDate"
          [max]="maxDate" />
        <mat-datepicker-toggle matSuffix [for]="startContract"></mat-datepicker-toggle>
        <mat-datepicker #startContract></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="col-12 col-lg-6 mb-2">
      <mat-form-field appearance="outline" [style.width.%]="100">
        <mat-label>{{ "endContract" | translate }}</mat-label>
        <input matInput [matDatepicker]="endContract" readonly="true" formControlName="endOfContractData"
          [min]="editWorkExperienceFormGroup.get('startOfContractDate').value" [max]="maxDate"
          [disabled]="isCurrentlyInRole" />
        <mat-datepicker-toggle matSuffix [for]="endContract"></mat-datepicker-toggle>
        <mat-datepicker #endContract></mat-datepicker>
      </mat-form-field>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-6 mb-2">
      <mat-form-field appearance="outline" [style.width.%]="100">
        <mat-label>{{ "occupation" | translate}}</mat-label>
        <input matInput formControlName="occupation" appCharactersOnly appNoLeadingSpaces />
      </mat-form-field>
    </div>
    <div class="col-lg-6 mb-2">
      <mat-form-field appearance="outline">
        <mat-label *ngIf="!showTagalog">{{ "employmentStatus" | translate }}</mat-label>
        <mat-select formControlName="employmentType">
          <mat-option *ngFor="let employmentType of employmentTypes" [value]="employmentType.name">{{
            employmentType.name }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div class="row mt-2">
    <div *ngIf="successMessage" class="success-message">
      {{ successMessage }}
    </div>
    <div *ngIf="errorMessage" class="error-message">
      {{ errorMessage }}
    </div>
  </div>

  <mat-progress-bar mode="indeterminate" *ngIf="isLicenseBeingUpdated"></mat-progress-bar>

  <div class="row mt-3 mb-1">
    <div class="col-12 col-lg-12">
      <div class="d-flex justify-content-end">
        <div class="col-12 col-lg-auto">
          <button mat-raised-button color="primary" class="text-white" (click)="updateWorkExperience()"
            [disabled]="isLicenseDisabled">Update</button>
        </div>
      </div>
    </div>
  </div>
</form>